<vectronic-card
  [title]="'Report Issue'"
  [displayClose]="!submitting"
  (closed)="!submitting && dialogRef.close()"
>
  <ng-container body>
    <mat-dialog-content class="dialog-body">
      <form [formGroup]="reportIssueForm" class="d-flex flex-column w-100" (ngSubmit)="onSubmit()">
        <mat-form-field class="mb-12">
          <mat-label>Subject</mat-label>
          <input
            matInput
            formControlName="subject"
            [readonly]="submitting"
            [matTooltip]="offlineTooltipMessage"
            [matTooltipDisabled]="isOnline"
          />
          @if (reportIssueForm.get('subject')?.invalid) {
            <mat-error> Subject is required. </mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Leave a comment</mat-label>
          <textarea
            matInput
            rows="15"
            formControlName="comment"
            [readonly]="submitting"
            [matTooltip]="offlineTooltipMessage"
            [matTooltipDisabled]="isOnline"
          ></textarea>
          @if (reportIssueForm.get('comment')?.hasError('required')) {
            <mat-error> Comment is required. </mat-error>
          }
          @if (reportIssueForm.get('comment')?.hasError('minlength')) {
            <mat-error> Comment must be at least 8 characters. </mat-error>
          }
        </mat-form-field>
        @if (isDesktop || isMobile) {
          <mat-checkbox
            class="ml-minus-10"
            formControlName="includeLogs"
            [disabled]="!isOnline || submitting"
            [matTooltip]="offlineTooltipMessage"
            [matTooltipDisabled]="isOnline"
            >Include Logs</mat-checkbox
          >
        }
        <vectronic-image-input
          [disabled]="submitting"
          (imagesSelected)="onImagesSelected($event)"
        ></vectronic-image-input>
      </form>
    </mat-dialog-content>

    <mat-dialog-actions class="actions-container">
      <div
        class="pl-12 d-flex pointer"
        [class.disabled-click]="submitting"
        (click)="!submitting && imageInput.triggerFileInput()"
      >
        <mat-icon>attachment</mat-icon> &nbsp;Upload Images...
      </div>
      <div>
        <button mat-button mat-dialog-close color="warn" [disabled]="submitting">
          <mat-icon>cancel</mat-icon>
          Cancel
        </button>
        <button
          mat-button
          color="accent"
          [disabled]="reportIssueForm.invalid || !isOnline || submitting"
          (click)="onSubmit()"
          [matTooltip]="offlineTooltipMessage"
          [matTooltipDisabled]="isOnline"
        >
          @if (submitting) {
            <mat-spinner color="accent" [diameter]="18" class="spinner-inline"></mat-spinner>
          } @else {
            <mat-icon>send</mat-icon>
          }
          Send
        </button>
      </div>
    </mat-dialog-actions>
  </ng-container>
</vectronic-card>
